import OAuth2_vue_vue_type_script_setup_true_lang_default from "./OAuth2.vue.script.js";
//#region src/v2/blocks/scalar-auth-selector-block/components/OAuth2.vue
var OAuth2_default = OAuth2_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { OAuth2_default as default };

//# sourceMappingURL=OAuth2.vue.js.map